module.exports = __webpack_public_path__ + "static/media/Flaticon.3e4331ee.ttf";